<div class="loading-overlay" *ngIf="loading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="stops-page-container">
  <div class="stops-content-wrapper">
      <div *ngIf="!isAdmin && !isSousAdmin" class="mb-6">
        <app-credit-disponible></app-credit-disponible>
      </div>

      <div class="stops-header flex-col sm:flex-row gap-4">
        <div class="flex items-center justify-center gap-4 w-full sm:w-auto">
          <h1 class="stops-title text-2xl sm:text-3xl">
            Gestion des stops
          </h1>
        </div>
      </div>

      <div *ngIf="isAdmin" class="mb-6">
        <div class="max-w-md mx-auto">
          <label class="block text-sm font-semibold text-gray-700 mb-2">Rechercher un client</label>
          <div class="relative">
            <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm">search</span>
            <input
              type="text"
              [(ngModel)]="filtreClient"
              (input)="onFilterChange()"
              placeholder="Rechercher un client..."
              class="w-full pl-9 pr-3 py-2 border border-gray-200 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm transition-all hover:border-gray-300 bg-white"
            />
          </div>
        </div>
      </div>

      <div class="stops-table-container">
        <div class="overflow-x-auto">
          <table class="stops-table">
            <thead class="stops-table-header">
              <tr>
                <th *ngIf="isAdmin" class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[150px] text-center" (click)="toggleSort('client')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Client</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'client' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'client'">↕</span>
                      <span *ngIf="sortField === 'client' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'client' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[120px] text-center" (click)="toggleSort('reponses')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Réponses</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'reponses' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'reponses'">↕</span>
                      <span *ngIf="sortField === 'reponses' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'reponses' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors min-w-[120px] text-center" (click)="toggleSort('stop')">
                  <div class="flex items-center justify-center gap-2">
                    <span>STOP</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'stop' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'stop'">↕</span>
                      <span *ngIf="sortField === 'stop' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'stop' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="min-w-[140px] text-center">Nouveaux</th>
                <th class="min-w-[120px] text-center">Tous</th>
                <th class="min-w-[140px] text-center">Réponses</th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr *ngFor="let c of filteredClients" class="stops-table-row">
                <td *ngIf="isAdmin" class="stops-table-cell text-center font-medium text-gray-800">
                  {{ c.identifiant }}
                </td>
                <td class="stops-table-cell text-center font-semibold text-gray-800">
                  {{ c.totalStop || 0 }}
                </td>
                <td class="stops-table-cell text-center font-semibold text-gray-800">
                  {{ c.totalFailed || 0 }}
                </td>
                <td class="stops-table-cell text-center">
                  <button 
                    class="stops-btn-export stops-btn-new" 
                    (click)="exporterNouveauxStops(c._id)"
                    title="Exporter les nouveaux stops">
                    <span class="material-symbols-outlined text-base">download</span>
                    <span>Nouveaux</span>
                  </button>
                </td>
                <td class="stops-table-cell text-center">
                  <button 
                    class="stops-btn-export stops-btn-all" 
                    (click)="exporterTousStops(c._id)"
                    title="Exporter tous les stops">
                    <span class="material-symbols-outlined text-base">download</span>
                    <span>Tous</span>
                  </button>
                </td>
                <td class="stops-table-cell text-center">
                  <button 
                    class="stops-btn-export stops-btn-reponses" 
                    (click)="exporterReponses(c._id)"
                    title="Exporter les réponses">
                    <span class="material-symbols-outlined text-base">download</span>
                    <span>Réponses</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</div>
